import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { FileboxOperationEnum } from '../enums/filebox-operation.enum';
import { FileboxStatusEnum } from '../enums/filebox-status.enum';

/**
 * Create filebox DTO
 */
export class CreateFileboxDto {
	color?: string;
	@TransformInt()
	tenantId!: number;
	@TransformInt()
	userId!: number;
	status!: FileboxStatusEnum;
	operation!: FileboxOperationEnum;
	key!: string;
	fileUuid!: string;
	synchronizationToken!: string;
	@TransformInt()
	retryCount!: number;
	@TransformDate()
	nextRetryAt?: Date;
	leasedBy?: string;
	@TransformDate()
	leasedUntil?: Date;
	@TransformDate()
	synchronizedAt?: Date;
	synchronizationError?: string;
}
